import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE'

export function updateProfile(body) {
  return {
    [CALL_API]: {
      endpoint: '/api/account/profile/',
      types: [UPDATE_USER_REQUEST, UPDATE_USER_SUCCESS, UPDATE_USER_FAILURE],
      method: 'PATCH',
      tokenType: API_JWT_TOKEN_NAME,
      body,
    },
  }
}
